import { formatInTimeZone } from 'date-fns-tz'
import { DEFAULT_RANGE_DAYS } from '../config'

const DAY_MS = 24 * 60 * 60 * 1000

/** The API's own default window, in UTC calendar dates: `DEFAULT_RANGE_DAYS` before today. */
export function getDefaultDateRange(now = new Date()) {
  return {
    dateFrom: formatInTimeZone(now.getTime() - DEFAULT_RANGE_DAYS * DAY_MS, 'UTC', 'yyyy-MM-dd'),
    dateTo: formatInTimeZone(now, 'UTC', 'yyyy-MM-dd'),
  }
}
